import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    url: 'https://keycloak.ceresis.rid-intrasoft.eu/',
    realm: 'ceresis',
    clientId: 'ceresis'
});

export default keycloak;